import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_COMMISSIONS_LEVEL_QUERY_PARAMS } from "../api";
import { CommissionsLevelForm } from "../components/forms/CommissionsLevelForm";
import CommissionsLevelFilterView from "../components/views/list/CommissionsLevelFilterView";
import CommissionsLevelTableView from "../components/views/list/CommissionsLevelTableView";
import { CommissionsSettingsLevelFilterPageRequest } from "../types";

export const CommissionsLevelListContainer = () => {
  const [levelFormOpen, setLevelFormOpen] = useState<boolean>(false);

  const searchParams = useFilterSearchParams<CommissionsSettingsLevelFilterPageRequest>({
    params: ["type"],
    defaultQueryParamsObject: DEFAULT_COMMISSIONS_LEVEL_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <CommissionsLevelFilterView searchParams={searchParams} onCreateClick={() => setLevelFormOpen(true)} />

      <CommissionsLevelTableView searchParams={searchParams} />

      <CommissionsLevelForm open={levelFormOpen} onFormCancel={() => setLevelFormOpen(false)} />
    </ContentWrapper>
  );
};
